
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/publish",
      function () {
        return require("private-next-pages/dashboard/publish.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/publish"])
      });
    }
  